import { render, staticRenderFns } from "./dialog_addGrowth.vue?vue&type=template&id=67ad373f&scoped=true&"
import script from "./dialog_addGrowth.vue?vue&type=script&lang=js&"
export * from "./dialog_addGrowth.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addGrowth.vue?vue&type=style&index=0&id=67ad373f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad373f",
  null
  
)

export default component.exports